rjm.ui.ChartBuilderFiltersView = rjm.ui.ChartBuilderBlockableView.extend(
  events:
    "click .cancel": "removeFilter"
    "keyup .restriction-sequence-string": "changeSequence"
    "click .add-filter": "addFilter"
    "click #applyFilter": "applyRestrictionSet"
    "click #cancelFilter": "cancel"

  initialize: (options) ->
    if not options or not options.chartModel or not options.viewState
      throw "InvalidConstructorArgs - ChartBuilderSeriesFiltersView"

    _.bindAll this, "rebindEventsAndPointers", "handleSequenceValidityChange", "changeSequence", "addFilter", 
      "removeFilter", "applyRestrictionSet", "cancel", "setButtonsState", "disableButtons", "enableButtons", 
      "recordChange", "restrictionsValid", "trendChanged", "generateTemplateData", "render"
    @chartModel = options.chartModel
    @restrictionSet = @chartModel.get("series").at(0).get("restrictionSet").clone()
    @viewState = options.viewState

    #GA trends wont have an op column here
    @trendSid = @chartModel.getCurrentSeries().get("trend").get("operationColumn")?.get("sid")

    @listenTo @viewState, "change:renderButtons", @cancel #to reRender filters after a saveAs
    @listenTo @chartModel.getCurrentSeries(), "change:trend", @trendChanged
    @rebindEventsAndPointers()

    @listenTo @chartModel, "change:api_conn_id", @block
    @listenTo @chartModel.getCurrentSeries(), "change:trend", @unblock
    @listenTo @chartModel, "clearFilters", (chartModel, options) =>
      @restrictionSet = @chartModel.get("series").at(0).get("restrictionSet").clone()
      @rebindEventsAndPointers()
      @viewState.set filtersApplied: true
      @render()
    return

  #because we are clonning restrictionSet we need to rebind events to the new clone and the local pointers to the new objects
  rebindEventsAndPointers: ->
    @listenTo @restrictionSet, "change", @render

    @restrictionSequence = @restrictionSet.get("sequence")
    @restrictions = @restrictionSet.get("restrictions")

    @listenTo @restrictionSequence, "stringValidChange", @handleSequenceValidityChange

    # we need to watch the restrictions collection and the sequence for any changes and make sure we note them    
    @listenTo @restrictions, "add remove change", @recordChange
    @listenTo @restrictionSequence, "change", @recordChange
    return

  #this is called when a sequence goes from valid to invalid or vice versa, takes care of setting the view state appropriately
  handleSequenceValidityChange: (isValidSequence, errorMessage) ->
    chartValidationErrors = jQuery.extend(true, {}, @viewState.get("chartValidationErrors")) #necessary to clone the object so that setting the viewstate will actually cause a change event
    seqEl = $(@el).find("#restrictionSequenceString")
    filterSequence = $(@el).find("#filterSequence")
    filterDelButtons = $(@el).find(".cancel")
    filterAddButton = $(@el).find(".add-filter")
    unless isValidSequence
      chartValidationErrors.restrictionSequence = errorMessage
      $(filterSequence).addClass "error"
      $(filterSequence).addClass "invalid"
      $(filterDelButtons).prop "disabled", true
      $(filterDelButtons).addClass "blocked"
      $(filterAddButton).prop "disabled", true
      $(filterAddButton).addClass "disabled"
      $(@el).find("#invalidRestrictionSequenceStringMessage").text errorMessage
    else
      delete chartValidationErrors.restrictionSequence
      $(filterSequence).removeClass "error"
      $(filterSequence).removeClass "invalid"
      $(filterDelButtons).prop "disabled", false
      $(filterDelButtons).removeClass "blocked"
      $(filterAddButton).prop "disabled", false
      $(filterAddButton).removeClass "disabled"
      $(@el).find("#invalidRestrictionSequenceStringMessage").text ""
    @viewState.set chartValidationErrors: chartValidationErrors
    @setButtonsState()
    return

  changeSequence: (e) ->
    newString = $(e.target).val()
    @restrictionSet.get("sequence").set string: newString

  addFilter: (e) ->
    e.preventDefault()
    sid = @chartModel.getCurrentSeries().get("trend").get("slicers").models[0].get("sid")
    lsColumn = new rjm.model.LSColumn(sid: sid)
    restriction = new rjm.model.Restriction(
      left: lsColumn
      op: rjm.app.enums.comparisonOperator.EQUAL
      right: ""
    )
    @restrictionSet.addRestriction restriction, "and"

  removeFilter: (e) ->
    e.preventDefault()
    index = $(e.target).data("index")
    @restrictionSet.removeRestrictionByIndex index

  applyRestrictionSet: (e)->
    e.preventDefault()
    @viewState.set filtersApplied: true
    @chartModel.getCurrentSeries().set(restrictionSet: @restrictionSet.clone())
    @disableButtons()

  cancel: (e)->
    if e.preventDefault? #when called from a bind e does not have preventDefault
      e.preventDefault()
    @viewState.set filtersApplied: true
    @stopListening @restrictionSet
    @restrictionSet = @chartModel.getCurrentSeries().get('restrictionSet').clone()
    @rebindEventsAndPointers()
    @render()

  setButtonsState: ->
    if _(@viewState.get("chartValidationErrors")).isEmpty() and @restrictionsValid() and not @restrictionSet.equal(@chartModel.getCurrentSeries().get("restrictionSet"))
      @enableButtons()
    else
      @disableButtons()

  disableButtons: ->
    $(@el).find("#filterButtons button").attr "disabled"

  enableButtons: ->
    $(@el).find("#filterButtons button").removeAttr "disabled"

  recordChange: ->
    @viewState.set filtersApplied: @restrictionSet.equal(@chartModel.getCurrentSeries().get("restrictionSet"))
    @setButtonsState()

  restrictionsValid: ->
    @restrictionSet.get("restrictions").reduce((memo, restriction) -> 
      memo and restriction.isValid()
    , true)

  trendChanged: -> #reset cloned restriction set to be blank if the new trend isn't built off of the same column or if its a GA chart (always reset)
    if @chartModel.isGAChart() or @chartModel.getCurrentSeries().get("trend").get("operationColumn").get("sid") isnt @trendSid
      @restrictionSet = new rjm.model.RestrictionSet
        restrictions:[]
        sequence:
          string:""
      @rebindEventsAndPointers()
      @render()

  generateTemplateData: ->
    seqString: @restrictionSet.get("sequence").get("string")

  block: ->
    rjm.ui.ChartBuilderBlockableView.prototype.block.apply(this, arguments);
    @$('.filters.unstyled.blocked.message').removeClass("blocked message")

  render: ->
    $(@el).html ich.chartBuilderFilters(@generateTemplateData())   
    @restrictionSet.get("restrictions").each (restriction, index) =>
      #for each restriction make the view, render it, append it to the ul and listen for the remove event
      #to remove the view from the DOM and get make sure it gets GCed
      view = new rjm.ui.ChartBuilderFilterItemView
        trend: @chartModel.getCurrentSeries().get("trend")
        restriction: restriction
        restrictionIndex: index
        chartModel: @chartModel
      @$('ul.filters').append view.el
      view.render()
      view.listenTo restriction, "remove", view.remove

    @setButtonsState()

    return @
)
